export default __webpack_public_path__ + "static/media/388.00343fbf.jpg";